import { AudioDto, GenerateStatus } from '@/service/type';
import { create } from 'zustand';
import { AudioDetailResponse } from '../service/interface';

export type AudioDetail = AudioDetailResponse['data'];

interface StoreState {
  audioDetail: AudioDetail | null;
  setAudioDetail: (audioDetail: AudioDetail | null) => void;
  updateAudioDetail: (partialAudioDetail: Partial<AudioDetail>) => void;
}

export const useAudioDetailStore = create<StoreState>((set, get) => {
  return {
    audioDetail: null,
    setAudioDetail: (audioDetail: AudioDetail | null) => set({ audioDetail }),
    updateAudioDetail: (partialAudioDetail: Partial<AudioDetail>) => {
      const currentAudioDetail = get().audioDetail;
      if (
        currentAudioDetail &&
        partialAudioDetail?.id === currentAudioDetail.id
      ) {
        set({
          audioDetail: {
            ...currentAudioDetail,
            ...partialAudioDetail,
          },
        });
      }
    },
  };
});
